var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 100 100",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.9,75.79V22.41H51.59c-11.07,2-22.11,3.85-33.22,5.77V78.67c10.93,1.93,22,3.86,33,5.86h4.5V75.79ZM39.62,64.71A85.15,85.15,0,0,1,36,55.65c-1,2.93-2.38,5.69-3.51,8.56-1.58,0-3.16-.09-4.74-.15,1.85-3.63,3.64-7.29,5.55-10.89-1.62-3.72-3.41-7.36-5.08-11.05L33,41.85c1.07,2.82,2.25,5.61,3.14,8.5,1-3.07,2.37-6,3.59-8.92q2.45-.17,4.91-.3Q41.76,47.05,38.83,53c2,4,4,8.05,6,12.09C43.09,64.95,41.36,64.84,39.62,64.71Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.72,29.33v3.83h7.65v5.65H57.72v3.1h7.65v5.65H57.72v3.1h7.65V56.3H57.72v3.1h7.65V65H57.72v3.28h7.65v5.47H57.72v3.83H84.14V29.33ZM78.31,73.79H67.19V68.32H78.31Zm0-8.75H67.19V59.39H78.31Zm0-8.75H67.19V50.65H78.31Zm0-8.75H67.19V41.9H78.31Zm0-8.75H67.19V33.16H78.31Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.4583023bafe2537aa36153cafe556a0d.svg";
export { ForwardRef as ReactComponent };